var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn',{class:_vm.classes,attrs:{"icon":"","small":""},on:{"click":_vm.requestFullscreenToggle}},[_c('fullscreen-icon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }